import { render, staticRenderFns } from "./EPainelComponentesCurriculares.vue?vue&type=template&id=4250bc30"
import script from "./EPainelComponentesCurriculares.vue?vue&type=script&lang=js"
export * from "./EPainelComponentesCurriculares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports